import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-2 w-full overflow-y-auto h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CargoDisputeForm = _resolveComponent("CargoDisputeForm")!
  const _component_CargoV2ManualInput = _resolveComponent("CargoV2ManualInput")!
  const _component_scan_table_section = _resolveComponent("scan-table-section")!
  const _component_CreateCargoRtcLayout = _resolveComponent("CreateCargoRtcLayout")!

  return (_openBlock(), _createBlock(_component_CreateCargoRtcLayout, {
    detailData: _ctx.rtcDetailData,
    disabledSelectSchedule: _ctx.disabledSelectSchedule,
    disabledBooking: _ctx.disabledBooking,
    disabledChangeTransport: _ctx.disabledChangeTransport,
    showSelectSchedule: _ctx.showSelectSchedule,
    cargoType: _ctx.form.cargoType?.value || '',
    onChangeCargoType: _ctx.onChangeCargoType,
    onBooking: _ctx.checkBooking,
    onSelectSchedule: _ctx.onSelectSchedule
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        (_ctx.showForm)
          ? (_openBlock(), _createBlock(_component_CargoDisputeForm, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.rtcDetailData.id && _ctx.showForm)
          ? (_openBlock(), _createBlock(_component_CargoV2ManualInput, {
              key: 1,
              form: _ctx.form,
              "onUpdate:form": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form = $event)),
              transportType: _ctx.form.cargoType
            }, null, 8, ["form", "transportType"]))
          : _createCommentVNode("", true),
        (_ctx.showForm)
          ? (_openBlock(), _createBlock(_component_scan_table_section, { key: 2 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["detailData", "disabledSelectSchedule", "disabledBooking", "disabledChangeTransport", "showSelectSchedule", "cargoType", "onChangeCargoType", "onBooking", "onSelectSchedule"]))
}